import styled, { css } from "styled-components"

import Button from "~/components/Button"

export type ChartCategory = "sales" | "visitors" | "unique-visitors"

const ChartCategorySelector: React.FC<{
	selectedValue: ChartCategory
	onChange: (newValue: ChartCategory) => void
}> = ({ selectedValue, onChange }) => {
	const options: { id: ChartCategory; label: string }[] = [
		{ id: "sales", label: "Sales" },
		{ id: "visitors", label: "Visitors" },
		{ id: "unique-visitors", label: "Unique visitors" },
	]
	return (
		<Container>
			{options.map(option => (
				<Option key={option.id} isActive={selectedValue === option.id} onClick={() => onChange(option.id)}>
					{option.label}
				</Option>
			))}
		</Container>
	)
}

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	background-color: var(--color-component-background);
	padding: 4px;
	border-radius: 12px;
`

const Option = styled(Button)<{ isActive: boolean }>`
	font-weight: 600;
	font-size: 14px;
	color: #475569;
	text-decoration: none;
	border-radius: 8px;
	padding: 10px 14px;
	transition: background-color 150ms, color 150ms;
	display: flex;
	align-items: center;
	gap: 8px;

	${props =>
		props.isActive &&
		css`
			color: ${props => props.theme.primaryColor};
			background-color: ${props => props.theme.primaryColor}14;
		`}
`

export default ChartCategorySelector
